export default __webpack_public_path__ + "static/media/modify-2.c97c975e.png";